import * as React from 'react';
export const doordashSvg = React.forwardRef(function doordashSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F4F7FA',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement(
      'g',
      null,
      /*#__PURE__*/ React.createElement('path', {
        d: 'M27.765 12.438a6.471 6.471 0 0 0-5.735-3.436H3.87a.624.624 0 0 0-.437 1.065l3.955 3.979a1.846 1.846 0 0 0 1.317.543H21.51a1.651 1.651 0 0 1 .034 3.302h-8.827a.626.626 0 0 0-.44 1.065l3.956 3.979c.351.348.825.543 1.32.543h3.991c5.193 0 9.119-5.554 6.22-11.063',
        fill: '#EB1700',
      }),
    ),
  );
});
doordashSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var doordash = {
  category: 'brand',
  colorable: false,
  name: 'doordash',
  svg: doordashSvg,
};
